import React from 'react';
import { Card } from 'components/ui/Card';
import { quickActions, QuickAction } from 'constants/quickActions';
import { Icon } from 'components/ui';

interface QuickActionsProps {
  onQuickAction: (prompt: string) => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({ onQuickAction }) => {
  const getColor = (icon: string) => {
    switch (icon) {
      case 'position':
        return 'bg-link/20';
      case 'search':
        return 'bg-orange-200';
      case 'write':
        return 'bg-blue-100';
      case 'linkedin':
        return 'bg-blue-200';
      case 'x':
        return 'bg-gray-200';
      case 'share':
        return 'bg-cyan-100';
      case 'pencil':
        return 'bg-purple-100';
      case 'structure':
        return 'bg-yellow-100';
      case 'fit':
        return 'bg-red-100';

      default:
        break;
    }
  };

  const handleQuickActionClick = (prompt: string) => {
    onQuickAction(prompt);
    // Focus on input after quick action is selected
    setTimeout(() => {
      const textarea = document.querySelector('textarea[placeholder="Describe what you need..."]');
      if (textarea) {
        (textarea as HTMLTextAreaElement).focus();
      }
    }, 100);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 max-w-4xl mb-8 px-4 md:px-0">
      {quickActions.map((action: QuickAction, index: number) => (
        <Card
          key={index}
          variant="onboarding"
          className="p-4 min-h-28 bg-white border hover:border-purple-300 hover:shadow-md transition-all cursor-pointer"
          onClick={() => handleQuickActionClick(action.prompt)}
        >
          <div className="flex items-start gap-3">
            <span
              className={`p-2 rounded-md flex items-center justify-center ${getColor(action.icon)}`}
            >
              <Icon className={`w-4 h-4`} type={action.icon} />
            </span>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-1">{action.title}</h3>
              <p className="text-sm text-gray-600">{action.description}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default QuickActions;
